import RouteItem from ".";
//about SubMenu Pages
import About from "../pages/about/About";
import Vision from "../pages/about/Vision";
import History from "../pages/about/History";
import Principal from "../pages/about/Principal";
import Chairman from "../pages/about/Chairman";
import Visitor from "../pages/about/Visitor";
import Co_ordinator from "../pages/about/Co-ordinator";
import PageUnderConstruction from "../pages/error-page/PageUnderConstruction";

export const aboutRoutes: RouteItem = {
  key: "router-about",
  title: "About",
  tooltip: "About",
  path: "/about",
  enabled: true,
  appendDivider: true,
  showInHeader: true,
  subRoutes: [
    {
      key: "router-about-college",
      title: "College",
      tooltip: "College",
      path: "about",
      enabled: true,
      component: About,
      appendDivider: true,
    },
    {
      key: "router-vision",
      title: "Vision & Mission",
      tooltip: "Vision",
      path: "vision-&-mission",
      enabled: true,
      component: Vision,
      appendDivider: true,
    },
    {
      key: "router-history",
      title: "History",
      tooltip: "History",
      path: "history",
      enabled: true,
      component: History,
      appendDivider: true,
    },
    {
      key: "router-chairman",
      title: "Chairman",
      tooltip: "Chairman",
      path: "chairman",
      enabled: true,
      component: Chairman,
      appendDivider: true,
    },
    // {
    //   key: "router-visitor",
    //   title: "Visitor",
    //   tooltip: "Visitor",
    //   path: "visitor",
    //   enabled: true,
    //   component: Visitor,
    //   appendDivider: true,
    // },
    {
      key: "router-co-ordinator",
      title: "Co-ordinator",
      tooltip: "Co-ordinator",
      path: "co-ordinator",
      enabled: true,
      component: Co_ordinator,
      appendDivider: true,
    },
    {
      key: "router-principal",
      title: "Principal",
      tooltip: "Principal",
      path: "principal",
      enabled: true,
      component: Principal,
      appendDivider: true,
    },

    // {
    //   key: "router-student-responsibilities",
    //   title: "Student's Responsibilities",
    //   tooltip: "Student Responsibiliy",
    //   path: "student's-responsibilities",
    //   enabled: true,
    //   component: PageUnderConstruction,
    //   appendDivider: true,
    // },
    // {
    //   key: "router-institute-responsibilities",
    //   title: "Institute's Responsibilities",
    //   tooltip: "Institute Responsibiliy",
    //   path: "institute's-responsibilities",
    //   enabled: true,
    //   component: PageUnderConstruction,
    //   appendDivider: true,
    // },
  ],
};
